// Backend call for "Save a job" on Drafts (backend/app.py jobs_lookup).

import { auth } from "../firebase";

const API_BASE = process.env.REACT_APP_API_URL ?? "http://localhost:5050";

/** What a job link says. Empty strings: not found, the user types them. */
export type JobLookup = {
  url: string;
  company: string;
  role: string;
  location: string;
  /** yyyy-mm-dd */
  deadline: string;
  found_by: string;
  /** "figma.com", for the website icon */
  domain: string;
  /** https image URL */
  logo: string;
};

/** Company, role, location and deadline for a pasted link. Throws "not a link" on a 400. */
export async function lookupJob(url: string): Promise<JobLookup> {
  const user = auth.currentUser;
  if (!user) throw new Error("Not signed in");
  const response = await fetch(`${API_BASE}/jobs/lookup?url=${encodeURIComponent(url)}`, {
    headers: { Authorization: `Bearer ${await user.getIdToken()}` },
  });
  if (response.status === 400) throw new Error("not a link");
  if (!response.ok) throw new Error(`Lookup failed: ${response.status}`);
  return response.json();
}
